import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import * as api from '../../actions/api';
import Form, { FormActions } from '../Form';

@inject('permissionStore')
@observer
class PermissionList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable permissions = [];
  @observable permissionsObj = {};
  @observable allRoles = [];

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const { permissionStore, params: { id } } = this.props;
    this.reset();
  }

  @action reset() {
    const { permissionStore } = this.props;
    api.permission.fetchAll()
      .then(action((items) => {
        this.permissions = items.permissions;
        this.permissionsObj = items.permissions.reduce((acc, perm) => {
          return Object.assign({}, acc, {
            [perm.permission]: perm.roles,
          });
        }, {});
        this.allRoles = items.all_roles;
      }))
      .catch(action(err => {
        this.context.notify.error(err);
        console.log('err', err);
      }));
  }

  handleDelete(idOrIds) {
    console.log('handleDelete', idOrIds);
    this.props.permissionStore.removeItems(idOrIds);
  }

  slug = '/permission';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
  ];

  handleSave(e) {
    e.preventDefault();
    console.log('handleSave', this.permissions);

    const { permissionStore } = this.props;
    const { notify } = this.context;

    api.permission.create(this.permissions)
      .then(() => {
        notify.success({ message: 'Success' });
        this.context.router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
        this.context.router.push(this.slug);
      });
  }

  onChangeCheckbox(roleId, permission) {
    this.permissions = this.permissions.map(permissionItem => {
      if (permissionItem.permission === permission) {
        const permissionRoles = permissionItem.roles || [];
        const idx = permissionRoles.indexOf(roleId);
        let roles;
        if (idx === -1) {
          roles = [
            ...permissionRoles,
            roleId,
          ];
        } else {
          roles = permissionRoles.slice(0, idx).concat(permissionRoles.slice(idx + 1));
        }
        return {
          ...permissionItem,
          roles,
        };
      }
      return permissionItem;
    });
  }

  render() {
    const { permissionStore } = this.props;
    // const { route: { permissionStore }, children } = this.props;
    const { children } = this.props;

    return (
      <Form>
        <div className={'DataTable'}>
          <table>
            <thead>
              <tr>
                <th />
                {this.allRoles.map(role => {
                  return <th key={role.name}>{role.name}</th>;
                })}
              </tr>
            </thead>
            {this.permissions.map(item => {
              return (
                <tbody key={item.permission}>
                  <tr>
                    <td>
                      <em>{item.resource}: </em> {item.permission}
                    </td>
                    {this.allRoles.map(role => {
                      return <td key={role.name}>
                        <input type="checkbox"
                          onChange={this.onChangeCheckbox.bind(this, role.id, item.permission)}
                          defaultChecked={item.roles && item.roles.indexOf(role.id) > -1}
                        />
                      </td>;
                    })}
                  </tr>
                </tbody>
              );
            })}
          </table>
        </div>
        <FormActions>
          <button onClick={this.handleSave}>Save</button>
        </FormActions>
      </Form>
    );
  }
}

export default PermissionList;



// WEBPACK FOOTER //
// ./src/components/Permission/PermissionList.js